import { Collapse } from 'antd';
import { FC } from 'react';
import { footerReducer } from '../../../antd-reducer/footer-reducer';
import { obtenerIcono } from '../../util/AppIcons';
import { FollowUs } from '../footer/FollowUs';
import './FooterMobile.less';

const { Panel } = Collapse;

export const FooterMobile:FC<{}> = (props) => {

    return (
    <div className='footer-mobile'>
        <div className='link-section'>
            {
                footerReducer.sections.map(({ key, title, items }) => {
                    return (
                    <div key={key}>
                        { title !== 'SÍGUENOS'
                            ?<Collapse className='title'>
                                <Panel header={title} key={key} className='list-item'>
                                {
                                    items.map(({ key, title, url }) => {
                                        return (
                                        <p className='item' key={key}>
                                            <a href={url}>{ title }</a>
                                        </p>
                                        )
                                    })
                                }
                                </Panel>
                            </Collapse>
                            : <FollowUs></FollowUs>
                        }
                    </div>
                    )
                })
            }
        </div>
        <div className='logos-section'>
            <div className='logos'>
                <div className='logos-group'>
                    <div className='logo'>
                        { obtenerIcono(`logo-derco-maq-footer-mb`) }
                    </div>
                    <div className='logo'>
                        { obtenerIcono(`logo-derco-center-footer-mb`) }
                    </div>
                    <div className='logo'>
                        { obtenerIcono(`logo-autopia-footer-mb`) }
                    </div>
                </div>
                <div className='logos-group'>
                <div className='logo'>
                        { obtenerIcono(`logo-autoplanet-footer-mb`) }
                    </div>
                    <div className='logo'>
                        { obtenerIcono(`logo-agroplanet-footer-mb`) }
                    </div>
                </div>
            </div>
            <div className='svg logo-center'>
                { obtenerIcono(`logo-derco-footer-mb`) }
            </div>
            <div className='divider'></div>
            <p className='copyright'>
                { footerReducer.copyright }
            </p>
        </div>
    </div>
    )
}